import { createPageApp } from '@/lib/createPageApp'
import TeacherDashboardPage from './TeacherDashboardPage.vue'

createPageApp(TeacherDashboardPage).mount()
